import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FilterOption } from 'src/app/models/filter-option';
import { TagsService } from 'src/app/services/tags.service';
import { NotificationService } from 'src/app/services/notification.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-tags',
  templateUrl: './tags.component.html',
  styleUrls: ['./tags.component.scss']
})
export class TagsComponent implements OnInit {
  private perPage=20;
  public loadingTags: boolean = true;
  public paginatedTags = new BehaviorSubject<any>(null);
  public availableFilters=[];
  private filterString='';

  constructor(
    private _tag: TagsService,
    private _route: Router,
    private _notify: NotificationService
  ) {
    this.availableFilters.push(new FilterOption({name:'tag',type:'string'}));
  }

  ngOnInit() {
    this.getTags(1);
  }

  public addNewTag(){
    if(!confirm('Confirm that you want to add a new Tag.')) return false;
    this._tag.createNewTag('New Tag').subscribe((res:any)=>{
      if(res.id) {
        this._notify.showMessage('Tag created.', 'OK');
        this._route.navigate(['/tags/'+res.id]);
      }
    });
  }

  pageChanged(data){
    this.perPage=data.pageSize;
    this.getTags(data.pageIndex+1);
  }

  perPageChanged(data){
    this.perPage=data.pageSize;
    this.getTags(1);
  }

  filterChanged(filters){
    this.filterString = filters;
    this.getTags(1);
  }

  public getTags(page){
    this._tag.getPaginatedTags(page,this.perPage,this.filterString).subscribe(paginatedData=>{
      this.paginatedTags.next(paginatedData);
      this.loadingTags = false;
    })
  }

}
